export default [
  {
    headerName: '',
    filter: false,
    children: [
      {
        headerName: '',
        field: 'ClassOfBusiness',
        filter: false,
        rowGroup: true,
        hide: true,
      },
      {
        headerName: '',
        filter: false,
        field: 'Subtitle',
        tooltipField: 'Subtitle',
        tooltipComponentParams: { field: 'Subtitle' },
      },
    ],
  },
  {
    headerName: 'FinalPremiums',
    headerClass: 'header-center background-grouped',
    filter: false,
    children: [
      {
        headerName: 'CurrentYear',
        field: 'CurrentYearAmt',
        tooltipField: 'CurrentYearAmt',
        tooltipComponentParams: {
          field: 'DiffCntPC',
          showCurrency: true,
        },
        headerClass: 'background-grouped header-center',
        cellRenderer: 'CellRendererMasterValue',
        cellRendererParams(params) {
          return {
            class: 'flex justify-between',
            unit: '€',
            unitPosition: 'start',
            returnFloat: true,
          }
        },
        maxWidth: 110,
      },
      {
        headerName: 'PreviousYear',
        field: 'PrevYearAmt',
        tooltipField: 'PrevYearAmt',
        tooltipComponentParams: {
          field: 'DiffCntPC',
          showCurrency: true,
        },
        headerClass: 'background-grouped header-center',
        cellRenderer: 'CellRendererMasterValue',
        cellRendererParams(params) {
          return {
            class: 'flex justify-between',
            unit: '€',
            unitPosition: 'start',
            returnFloat: true,
          }
        },
        maxWidth: 125,
      },
      {
        headerName: 'Variation',
        field: 'DiffAmtPC',
        tooltipField: 'DiffAmtPC',
        tooltipComponentParams: {
          field: 'DiffCntPC',
          showPercentage: true,
        },
        headerClass: 'background-grouped header-center',
        cellRenderer: 'CellRendererMasterValue',
        cellRendererParams(params) {
          return {
            class: 'flex justify-end',
            unit: '%',
            unitPosition: 'end',
            returnFloat: true,
          }
        },
        maxWidth: 85,
      },
    ],
  },
  {
    headerName: 'NumberOfContracts',
    headerClass: 'header-center background-grouped',
    children: [
      {
        headerName: 'CurrentYear',
        field: 'CurrentYearCnt',
        tooltipField: 'CurrentYearCnt',
        tooltipComponentParams: { field: 'CurrentYearCnt' },
        headerClass: 'header-center background-grouped',
        cellRenderer: 'CellRendererMasterValue',
        maxWidth: 110,
        cellRendererParams(params) {
          return {
            class: 'flex justify-end',
            unitPosition: 'end',
          }
        },
      },
      {
        headerName: 'PreviousYear',
        field: 'PrevYearCnt',
        tooltipField: 'PrevYearCnt',
        tooltipComponentParams: { field: 'PrevYearCnt' },
        headerClass: 'header-center background-grouped',
        cellRenderer: 'CellRendererMasterValue',
        maxWidth: 125,
        cellRendererParams(params) {
          return {
            class: 'flex justify-end',
            unitPosition: 'end',
          }
        },
      },
      {
        headerName: 'Variation',
        field: 'DiffCntPC',
        tooltipField: 'DiffCntPC',
        tooltipComponentParams: {
          field: 'DiffCntPC',
          showPercentage: true,
        },
        headerClass: 'background-grouped header-center',
        cellRenderer: 'CellRendererMasterValue',
        cellRendererParams(params) {
          return {
            class: 'flex justify-end',
            unit: '%',
            unitPosition: 'end',
            returnFloat: true,
          }
        },
        maxWidth: 85,
      },
    ],
  },
];

